import PropTypes from 'prop-types';
import React from 'react';

const StateIcon = ({ isCompleted, className = '' }) => {
	const iconClassName = `state-icon ${isCompleted ? 'state-icon--completed' : 'state-icon--todo'} ${className}`;

	return <span className={iconClassName} />;
};

StateIcon.propTypes = {
	isCompleted: PropTypes.bool.isRequired,
	className: PropTypes.string,
};

export default StateIcon;
